import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Input,
  Flex,
  useDisclosure,
  Tooltip,
  IconButton,
  Button,
  Checkbox,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  Spacer,
  Select,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  IHealthPlanItem,
  IHealthPlanMappingItem,
  IScenarioItem,
} from '../Infrastructure/Interfaces';
import TablePagination from '../TablePagination/TablePagination';
import useTable from '../TablePagination/UseTable';
import { BsPencilSquare } from 'react-icons/bs';
import HealthPlanMappingModalPoupup from './HealthPlanMappingModalPopup';
import {
  fetchHealthPlanMappingList,
  setHealthPlanMappingItem,
} from '../Store/HealthPlanMappingReducer';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import { FaMapSigns } from 'react-icons/fa';
import { HealthPlansMappingMultiUpdateModal } from './HealthPlanMappingMultiUpdateModal';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { ImBin } from 'react-icons/im';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import {
  fetchHealthPlanTypeList,
  fetchPayerAddressList,
  fetchSceneriosList,
} from '../Store/GetDropDownsValuesReducer';

interface Props {
  healthPlanMappingLists: IHealthPlanMappingItem[];
  region: string;
}

function HealthPlanMappingPg({ healthPlanMappingLists, region }: Props) {
  const [value, setValue] = useState('');
  const [TableFilter, setTableFilter] = useState(healthPlanMappingLists);
  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    value.length > 0 ? TableFilter : healthPlanMappingLists,
    currentPage,
    claimsPerPage
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenUnmappedModal,
    onOpen: onOpenUnmappedModal,
    onClose: onCloseUnmappedModal,
  } = useDisclosure();
  const dispatch = useDispatch<AppDispatch>();
  const [checkedHealthPlanNames, setcheckedHealthPlanNames] = useState<
    {
      healthPlanMappingId: number;
      healthPlanName: string;
      payerAddressId: number;
      scenarioId: number;
    }[]
  >([]);
  const [selectedHealthPlans, SetSelectedHealthPlans] = useState<
    IHealthPlanMappingItem[]
  >([]);

  const { instance, accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  const toast = useToast();
  const [toBeDeletedItem, setToBeDeleteItem] =
    useState<IHealthPlanMappingItem>();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();
  const cancelRef = React.useRef(null);
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);

  var scenariolist: IScenarioItem[] = useSelector((state: any) => {
    return state.scenariosList.scenariosList;
  });

  // useEffect(() => {
  //   dispatch(fetchPayerNameList());
  //   dispatch(fetchPayerAddressList());
  // }, []);

  function deleteItemDialog(item: IHealthPlanMappingItem) {
    setToBeDeleteItem(item);
    onDeleteModalOpen();
  }

  async function deleteItem(item: IHealthPlanMappingItem) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
    const url: string =
      baseurl +
      '/Payer/delete_healthplanmapping' +
      '?healthplanmappingid=' +
      item.healthPlanMappingId +
      '&userid=' +
      userid + '&user=' + accounts[0].username;

    await axios.get(tokenurl).then(async res => {
      if (res.data.success) {
        await axios
          .delete(url, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              toast({
                title: 'Success',
                description: item.healthPlanName + ' deleted successfully',
                position: 'top',
                status: 'success',
                duration: 10000,
                isClosable: true,
              });
              onDeleteModalClose();
              dispatch(fetchHealthPlanMappingList());
            }
          })
          .catch(error => {
            toast({
              title: 'Error!',
              description:
                error.response.data.message != ''
                  ? error.response.data.message
                  : error.message,
              position: 'top',
              status: 'error',
              duration: 4000,
              isClosable: true,
            });
            onDeleteModalClose();
          });
      }
    });
    setDeleteOkLoading(false);
  }

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = healthPlanMappingLists.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IHealthPlanMappingItem])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
    }
  };

  function openModal(mappedItem: IHealthPlanMappingItem) {
    //  dispatch(fetchPayerMasterList());
    //  dispatch(fetchHealthPlanTypeList());
    //  dispatch(fetchSceneriosList());
    //  dispatch(fetchPayerAddressList());
    var data = healthPlanMappingLists.find(
      item => item.healthPlanMappingId === mappedItem.healthPlanMappingId
    );
    var scenariodata = scenariolist.find(
      x => x.scenarioid == mappedItem.scenarioId
    );

    let healthPlanMasterId: number = data?.healthPlanMasterId!;
    let payerAddressId: number = data?.payerAddressId!;
    let payerName: string = data?.payerName!;
    let address: string = data?.address!;
    let city: string = data?.city!;
    let state: string = data?.state!;
    let zip: string = data?.zip!;
    let phoneNo: string = data?.phoneNo!;
    let faxNo: string = data?.faxNo!;
    let displayName: string = data?.displayName!;
    let isActive: boolean = data?.isActive!;
    let healthPlanTypeId: number = data?.healthPlanTypeId!;
    let healthPlanType: string = data?.healthPlanType!;
    let healthPlanName: string = data?.healthPlanName!;
    let region: string = data?.region!;
    let createdBy: string = data?.createdBy!;
    let createdOn: string = data?.createdOn!;
    let modifiedBy: string = data?.modifiedBy!;
    let modifiedOn: string = data?.modifiedOn!;
    let scenarioId: number = data?.scenarioId!;
    let scenaerioName: string = data?.scenarioName!;
    let deliverOption: string = scenariodata?.deliver_option!;
    let faxtofaxnumber: string = scenariodata?.fax_to_faxnumber!;
    let healthPlanId: string = data?.healthPlanId!;

    const item: IHealthPlanMappingItem = {
      healthPlanMappingId: mappedItem.healthPlanMappingId,
      healthPlanMasterId: healthPlanMasterId,
      payerAddressId: payerAddressId,
      payerName: payerName,
      address: address,
      city: city,
      state: state,
      zip: zip,
      phoneNo: phoneNo,
      faxNo: faxNo,
      displayName: displayName,
      isActive: isActive,
      healthPlanTypeId: healthPlanTypeId,
      healthPlanType: healthPlanType,
      healthPlanName: healthPlanName,
      region: region,
      createdBy: createdBy,
      createdOn: createdOn,
      modifiedBy: modifiedBy,
      modifiedOn: modifiedOn,
      scenarioId: scenarioId,
      scenarioName: scenaerioName,
      deliverOption: deliverOption,
      faxToFaxNumber: faxtofaxnumber,
      healthPlanId: healthPlanId,
    };
    dispatch(setHealthPlanMappingItem(item));
    onOpen();
  }

  const onCheckboxSelect = (mappedItem: IHealthPlanItem) => {
    const itemsCopy = Array.from(checkedHealthPlanNames);
    var index = checkedHealthPlanNames.findIndex(
      v => v.healthPlanMappingId == mappedItem.healthPlanMappingId
    );
    var payerindex = checkedHealthPlanNames.findIndex(
      v => v.payerAddressId == mappedItem.payerAddressId
    );
    var scenarioIndex = checkedHealthPlanNames.findIndex(
      d => d.scenarioId == mappedItem.scenarioId
    );
    var scenariodata = scenariolist.find(
      x => x.scenarioid == mappedItem.scenarioId
    );

    if (index === -1) {
      if (
        checkedHealthPlanNames.length === 0 ||
        (payerindex > -1 && scenarioIndex > -1)
      ) {
        setcheckedHealthPlanNames(checkedHealthPlanNames =>
          checkedHealthPlanNames.concat({
            healthPlanMappingId: mappedItem.healthPlanMappingId,
            healthPlanName: mappedItem.healthPlanName,
            payerAddressId: mappedItem.payerAddressId,
            scenarioId: mappedItem.scenarioId,
          })
        );
        SetSelectedHealthPlans([
          ...selectedHealthPlans,
          {
            healthPlanMappingId: mappedItem.healthPlanMappingId,
            healthPlanMasterId: mappedItem.healthPlanMasterId,
            healthPlanName: mappedItem.healthPlanName,
            displayName: mappedItem.displayName,
            healthPlanType: mappedItem.healthPlanType,
            healthPlanTypeId: mappedItem.healthPlanTypeId,
            payerAddressId: mappedItem.payerAddressId,
            payerName: mappedItem.payerName,
            address: mappedItem.address,
            city: mappedItem.city,
            state: mappedItem.state,
            zip: mappedItem.zip,
            phoneNo: mappedItem.phoneNo,
            faxNo: mappedItem.faxNo,
            region: mappedItem.region,
            scenarioId: mappedItem.scenarioId,
            scenarioName: mappedItem.scenarioName,
            deliverOption: scenariodata?.deliver_option!,
            faxToFaxNumber: scenariodata?.fax_to_faxnumber!,
            isActive: false,
            createdBy: '',
            createdOn: '',
            modifiedBy: '',
            modifiedOn: '',
            healthPlanId:mappedItem.healthPlanId,
          },
        ]);
      } else {
        toast({
          title: 'Warning!',
          description:
            'Please select health plans mapped to same Payer Address and having same scenario.',
          position: 'top',
          status: 'warning',
          duration: 6000,
          isClosable: true,
        });
      }
    } else {
      itemsCopy.splice(index, 1);
      setcheckedHealthPlanNames(itemsCopy);
      SetSelectedHealthPlans(
        selectedHealthPlans.filter(
          x => x.healthPlanMasterId !== mappedItem.healthPlanMasterId
        )
      );
    }
  };

  useEffect(() => {
    setcheckedHealthPlanNames([]);
    SetSelectedHealthPlans([]);
  }, [healthPlanMappingLists]);

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-end" paddingBottom=".5rem">
          {userrole.toUpperCase() != 'USER' && (
            <Button
              bg="#002677"
              color="white"
              variant="outline"
              size="md"
              leftIcon={<FaMapSigns />}
              mr={4}
              onClick={() => onOpenUnmappedModal()}
              isDisabled={checkedHealthPlanNames.length < 1 ? true : false}
            >
              Edit Mapping
            </Button>
          )}
          <Input
            htmlSize={24}
            width="auto"
            className="form-control"
            type="text"
            placeholder="Search table..."
            onChange={filterData}
            style={{ float: 'right', marginRight: '0.5rem' }}
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white" width={1}></Th>
                <Th color="white">HEALTH PLAN NAME</Th>
                <Th color="white">HEALTH PLAN ID</Th>
                <Th color="white">PAYER NAME</Th>
                <Th color="white">DISPLAY NAME</Th>
                <Th color="white">ADDRESS</Th>
                <Th color="white">CITY</Th>
                <Th color="white">STATE</Th>
                <Th color="white">ZIP</Th>
                <Th color="white">ACTIVE</Th>
                <Th color="white">REGION</Th>
                <Th color="white">DELIVERY OPTION</Th>
                {userrole.toUpperCase() != 'USER' && (
                  <Th color="white">ACTIONS</Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {(value.length > 0 ? TableFilter : healthPlanMappingLists)
                .slice(firstIndex, lastIndex)
                .map(healthplanmappeditem => {
                  const {
                    healthPlanMappingId,
                    healthPlanName,
                    healthPlanId,
                    payerName,
                    displayName,
                    address,
                    city,
                    state,
                    zip,
                    isActive,
                    region,
                    scenarioId,
                  } = healthplanmappeditem;

                  const isChecked = checkedHealthPlanNames.some(
                    x => x.healthPlanMappingId === healthPlanMappingId
                  );

                  const deliverOption =
                    scenariolist?.find(x => x.scenarioid === scenarioId)
                      ?.deliver_option || '';

                  return (
                    <Tr key={healthPlanMappingId} style={{ fontSize: '14px' }}>
                      <Td>
                        <Checkbox
                          isChecked={isChecked}
                          onChange={() =>
                            onCheckboxSelect(healthplanmappeditem)
                          }
                          border="black"
                        />
                      </Td>
                      <Td maxWidth={400} whiteSpace="pre">
                        {healthPlanName}
                      </Td>
                      <Td>{healthPlanId}</Td>
                      <Td>{payerName}</Td>
                      <Td>{displayName}</Td>
                      <Td>{address}</Td>
                      <Td>{city}</Td>
                      <Td>{state}</Td>
                      <Td>{zip}</Td>
                      <Td>{isActive ? 'True' : 'False'}</Td>
                      <Td>{region}</Td>
                      <Td>{deliverOption}</Td>
                      {userrole.toUpperCase() !== 'USER' && (
                        <Td pt="0" pb="0" mt="0" mb="0" pr="30px">
                          <Tooltip
                            hasArrow
                            label="Edit Mapping"
                            placement="left"
                          >
                            <IconButton
                              size="xs"
                              aria-label="edit"
                              icon={<BsPencilSquare />}
                              onClick={() => openModal(healthplanmappeditem)}
                            />
                          </Tooltip>
                          <Tooltip
                            hasArrow
                            label="Delete mapping"
                            bg="gray.300"
                            color="black"
                          >
                            <IconButton
                              size="xs"
                              ml={4}
                              aria-label="Delete"
                              icon={<ImBin />}
                              onClick={() =>
                                deleteItemDialog(healthplanmappeditem)
                              }
                            />
                          </Tooltip>
                        </Td>
                      )}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <HealthPlanMappingModalPoupup
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        region={region}
        pageNumber={currentPage}
      />
      <HealthPlansMappingMultiUpdateModal
        isOpen={isOpenUnmappedModal}
        onOpen={onOpenUnmappedModal}
        onClose={onCloseUnmappedModal}
        healthitems={selectedHealthPlans}
      />
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteModalClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Health Plan Mapping?
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              Are you sure you want to delete mapping of{' '}
              <b>{toBeDeletedItem?.healthPlanName}</b> ?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteModalClose}
                ml={3}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={() => deleteItem(toBeDeletedItem!)}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default HealthPlanMappingPg;
